<template>
  <div class="layout-header">
    <div
      class="fixed top-0 left-0 justify-center w-full bg-white headershadow"
      style="z-index: 1000"
    >
      <div class="w-full h-16 max-w-screen-xl m-auto">
        <div class="float-left">
          <img
            :src="$ossUrl + store.getters.getConfig.www_logo_src"
            v-if="store.getters.getConfig.is_header"
            class="float-left w-8 h-10 mt-2"
            @click="clickSilder('#col')"
          />
          <img
            v-if="!store.getters.getConfig.is_header"
            :src="$ossUrl + store.getters.getConfig.www_logo_src"
            class="float-left h-10 mt-3 w-15"
          />
          <div
            v-show="!store.getters.getConfig.is_header"
            class="float-left pt-3 pl-6 text-xl font-medium leading-10 text-black w-50"
          >
            浙江正信融资担保有限公司</div
          >
          <div class="flow-root pl-6" v-show="store.getters.getConfig.is_header">
            <a
              class="float-left w-20 pt-3 pl-6 text-base font-medium leading-10 text-black"
              @click="clickSilder('#col')"
              >首页</a
            >
            <a
              class="float-left pt-3 pl-6 text-base font-medium leading-10 text-black w-28"
              @click="$router.push('/projects')"
              >工程项目</a
            >
            <a
              class="float-left pt-3 pl-6 text-base font-medium leading-10 text-black w-28"
              @click="$router.push('/newss')"
              >新闻资讯</a
            >
            <a
              class="float-left pt-3 pl-6 text-base font-medium leading-10 text-black w-28"
              @click="clickSilder('#customer')"
              >合作伙伴</a
            >
            <a
              class="float-left pt-3 pl-6 text-base font-medium leading-10 text-black w-28"
              @click="clickSilder('#license')"
              >资质荣誉</a
            >
            <a
              class="float-left pt-3 pl-6 text-base font-medium leading-10 text-black w-28"
              @click="$router.push('/contract_check')"
              >保函查验</a
            >
            <a
              class="float-left pt-3 pl-6 text-base font-medium leading-10 text-black w-28"
              @click="gotoContracts"
              >保函订单</a
            >
          </div>
          <div style="float: none; clear: both"></div>
        </div>
        <div class="float-right">
          <UserDrop></UserDrop>
        </div>
        <div style="float: none; clear: both"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import UserDrop from './userdrop.vue';
  import store from '@/store/index';
  export default {
    name: 'Header',
    components: { UserDrop },
    data() {
      return {
        store: store,
      };
    },
    computed: {
      ...mapState('user', ['userInfo']),
    },
    watch: {
      '$route.query'(a) {
        if (a.anch) {
          setTimeout(() => {
            this.clickSilder(a.anch);
          }, 50);
        }
      },
    },
    created() {},
    mounted() {},
    methods: {
      clickSilder(anchro) {
        if (this.$route.path == '/index') {
          // 获取DOM元素
          let el = document.querySelector(anchro);
          // chrome
          document.body.scrollTop = el.offsetTop;
          // firefox
          document.documentElement.scrollTop = el.offsetTop;
        } else {
          this.$router.push({ path: '/', query: { anch: anchro } });
        }
      },
      async gotoContracts() {
        // if (!this.userInfo.id) {
        //   this.$store.commit('user/SET_LOGINFLAG', true);
        //   return;
        // }
        this.$router.push(`/admin/contract`);
      },
      cancelLogin() {
        this.$store.commit('user/SET_LOGINFLAG', false);
      },
    },
  };
</script>

<style lang="less" scoped>
  .headershadow {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.06);
  }
</style>
